import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL, S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import { StoresLinks, SuccessPageStyles } from './OneNightStand.styles';

interface OneNightStandBaseProps {
  backgroundImage: string;
}

const OneNightStandBase: React.FC<OneNightStandBaseProps> = ({
  backgroundImage,
}) => {
  const { user } = useAccount();

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  return (
    <SuccessPageStyles backgroundImage={backgroundImage}>
      <IonContent scrollY={false}>
        <div className="content">
          <OnboardingTitle className="success-payment-title">
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>
          <div className="next-actions">
            <UiTypography
              align="center"
              variant="body-large"
              className="next-action-description"
            >
              Choose the platform
            </UiTypography>
            <StoresLinks>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('appstore')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/appstore.png`}
                  alt="appstore"
                />
              </a>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('googleplay')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/googleplay.png`}
                  alt="googleplay"
                />
              </a>
            </StoresLinks>

            <UiTypography variant="body-large" align="center">
              OR via the link we sent to {user?.email} (check Inbox and Spam
              folders).
            </UiTypography>
          </div>

          <div className="questions-email">
            <UiTypography variant="body-large" align="center">
              If you have any questions - reach us at{' '}
              <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`}>
                {DIALOGUE_SUPPORT_EMAIL}
              </a>
            </UiTypography>
          </div>
        </div>
      </IonContent>
    </SuccessPageStyles>
  );
};

export default OneNightStandBase;
